import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { nike } from '@nike/nike-design-tokens';
import { mobileOnly, navMenuOpen, navScrollable } from '../../utils/sharedStyles';
import { iconTertiary, iconTertiaryHover } from '../../utils/inconsistentVars';
const { podiumCdsColorFocusRing } = nike;

export const MOBILE_BTN_CLASS = 'mobile-btn';
export const profileImageClass = 'profile-image';
export const profileLinkClass = 'profile-link';

// NOTE: this will need to be updated to whatever is the root/lowest level
// of header nav elements once header/footer is broken out to individual sections.
export const globalStyleNavOverflow = css`
  #root {
    overflow: clip;
  }

  // makes the background scrollable when geomismatch modal is open
  .nds-no-scroll.${navScrollable} {
    &:not(.${navMenuOpen}) {
      overflow: auto;
      position: static;
    }
  }
  .${navMenuOpen} {
    overflow: hidden;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
`;

/**
 * Podium uses css vars for the button icons that are not available on ncss 4.2
 * So overriding them using the values from sensible values that exist on both style sheets
 */
const btnIconsStyles = css`
  background: ${iconTertiary};
  color: var(--podium-cds-color-text-primary);

  &:hover,
  &:active {
    background: ${iconTertiaryHover};
  }
  &:focus-visible {
    box-shadow: 0 0 0 2px ${podiumCdsColorFocusRing};
  }
`;

export const scrim = 'scrim';
export const isOpen = 'is-open';
export const navFavorites = 'nav-favorites';
export const isVisible = 'is-visible';
export const aiIconContainer = 'ai-icon-container';

export const StyledDiv = styled.div`
  float: right;
  gap: 4px;
  flex: 0 0 auto;
  display: flex;
  a.${navFavorites} {
    flex: 0 0 auto;
  }
  @media (${mobileOnly}) {
    .${navFavorites} {
      display: none;

      &.${isVisible} {
        display: flex;
      }
    }
  }
  .nds-btn.nds-button--icon-only {
    ${btnIconsStyles}
  }

  .${aiIconContainer} {
    display: flex;
    align-items: center;
    padding: 6px;
    width: 36px;
    height: 36px;
    cursor: pointer;
    border-radius: var(--podium-cds-button-border-radius);
    ${btnIconsStyles}

    &:hover {
      background: ${iconTertiaryHover};
    }
  }

  > a {
    flex: 0 0 auto;
  }

  .${MOBILE_BTN_CLASS} {
    display: flex;
    padding-left: 10px;
  }

  .${profileImageClass} {
    border-radius: 24px;
    width: 24px;
    height: 24px;
    display: inline-block;
  }
  .${profileLinkClass} {
    display: flex;
    align-items: center;
    padding: 6px;
    border: none;
    border-radius: var(--podium-cds-button-border-radius);
    outline: none;
    ${btnIconsStyles}
  }

  .${scrim} {
    background-color: var(--podium-cds-color-scrim-100);
    bottom: 0;
    display: block;
    left: 0;
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 250ms, visibility 0s linear 250ms;
    visibility: hidden;
    z-index: 2;

    &.${isOpen} {
      opacity: 1;
      visibility: visible;
      transition: opacity 800ms ease, visibility 0s;
    }
    &.peakaboo-disabled {
      z-index: 2;
    }
  }
`;

export const BagContainer = styled.div`
  width: 24px;
  height: 24px;
  line-height: 1.75;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-align: center;
`;

export const BagCountText = styled.p`
  position: relative;
  font-size: 9px;
  top: -26px;
  left: 0px;
  width: 24px;
  height: 24px;
`;
